// axios
import axios from 'axios'

//const localhost = 'http://localhost/'
//const stage = 'http://ec2-18-234-80-3.compute-1.amazonaws.com/'
const prod = 'http://ec2-18-212-60-148.compute-1.amazonaws.com/'

const baseURL = prod

export default axios.create({
  baseURL
  // You can add your headers here
})
